export default {
    local: {
        landing_page_url: "https://acn-my-morri.appspot.com",
        client_id: "877614078106-ap72ofvi4b7d8rc6f3ad6rd6j01d22k2.apps.googleusercontent.com",
        email_domain: "test.morrisonsplc.co.uk",
        stub_oauth: true,
        ga_ua: "UA-91860945-5",
        ga_debug: true
    },
    localGAE: {
        landing_page_url: "https://acn-my-morri.appspot.com",
        client_id: "877614078106-ap72ofvi4b7d8rc6f3ad6rd6j01d22k2.apps.googleusercontent.com",
        email_domain: "test.morrisonsplc.co.uk",
        ga_ua: "",
    },
    dev: {
        landing_page_url: "https://acn-my-morri.appspot.com",
        client_id: "877614078106-ap72ofvi4b7d8rc6f3ad6rd6j01d22k2.apps.googleusercontent.com",
        email_domain: "test.morrisonsplc.co.uk",
        ga_ua: "UA-91860945-5",
    },
    qa: {
        landing_page_url: "https://acn-my-morri-qa.appspot.com",
        client_id: "877614078106-ap72ofvi4b7d8rc6f3ad6rd6j01d22k2.apps.googleusercontent.com",
        email_domain: "test.morrisonsplc.co.uk",
        ga_ua: "UA-91860945-6",
    },
    staging: {
        landing_page_url: "https://acn-my-morri-staging.appspot.com",
        client_id: "877614078106-ap72ofvi4b7d8rc6f3ad6rd6j01d22k2.apps.googleusercontent.com",
        email_domain: "test.morrisonsplc.co.uk"
    },
    preprod: {
        landing_page_url: "https://my-morri-pre.appspot.com",
        client_id: "877614078106-ap72ofvi4b7d8rc6f3ad6rd6j01d22k2.apps.googleusercontent.com",
        email_domain: "test.morrisonsplc.co.uk",
        ga_ua: "UA-91860945-7"
    },
    prod: {
        landing_page_url: "https://www.mymorri.com",
        client_id: "1073181092632-cq1jm2k776jb8cr0ghc07qel434pod6q.apps.googleusercontent.com",
        email_domain: "morrisonsplc.co.uk",
        ga_ua: "UA-91860945-8",
    }

}[process.env.REACT_APP_ENV]



// WEBPACK FOOTER //
// ./src/config.js